var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorRightLil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.-All-Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "COM/Error-404_1300",
    transform: "translate(-1080.000000, -512.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "animated-scene",
    transform: "translate(726.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Asset-16",
    transform: "translate(394.000000, 320.000000) scale(-1, 1) translate(-394.000000, -320.000000) translate(354.000000, 280.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F0503C",
    points: "0 0 40 0 80 40 40 40 80 80 0 80"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 23.7037037,
    y: 5.92592593,
    width: 20.7407407,
    height: 20.7407407
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 34.1814815,
    cy: 16.2962963,
    r: 7.40740741
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 53.3333333,
    y: 5.92592593,
    width: 20.7407407,
    height: 20.7407407
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 63.7037037,
    cy: 16.2962963,
    r: 7.40740741
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRightLil);
export default __webpack_public_path__ + "static/media/error_right_lil.dc2b3de50f2b828b2c9c831e3a3522e3.svg";
export { ForwardRef as ReactComponent };